import * as React from 'react';
import { motion } from 'framer-motion';
import {
  FaClock,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { useState } from 'react';

const ContactsPage: React.FC = () => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  // Contact Item Component
  interface ContactItemProps {
    IconComponent: React.ElementType; // Use React.ElementType for icon components
    label: string;
    children: React.ReactNode;
  }
  const ContactItem: React.FC<ContactItemProps> = ({ IconComponent, label, children }) => (
    <motion.div
      className="flex items-start gap-4"
      variants={itemVariants}
    >
      <IconComponent className="text-2xl text-black w-6 h-6" />
      <div className="text-sm">
        <p className="font-bold text-black mb-1">{label}</p>
        {children}
      </div>
    </motion.div>
  );


  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  const mapVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <motion.section
      className="py-24 bg-light"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-3xl lg:text-4xl text-dark mb-12 text-center"
          variants={itemVariants}
        >
          Contactos
        </motion.h2>

        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Contact Information */}
          <motion.div
            className="w-full order-2 lg:order-1 flex flex-col gap-4"
            variants={containerVariants}
          >
            <ContactItem IconComponent={FaClock} label="Horário">
              <p>De terça a sábado das 10:30 às 19h</p>
            </ContactItem>
            <a
              href="https://maps.app.goo.gl/16z1R94CNFtHpWzA6"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary transition duration-300"
            >
              <ContactItem IconComponent={FaMapMarkerAlt} label="Endereço">

                <p className="hover:text-primary transition duration-300">Rua Tito Moreira Rato, Loja 10A Oeiras 2770-224</p>
              </ContactItem>
            </a>
            <ContactItem IconComponent={FaPhone} label="Telefone">
              <a href="tel:214406827" className="hover:text-primary transition duration-300">
                <p className="hover:text-primary transition duration-300">214 406 827</p>
              </a>
              <a href="tel:+351919167389" className="hover:text-primary transition duration-300">
                <p className="hover:text-primary transition duration-300">+351 919 167 389</p>
              </a>
            </ContactItem>
            <a href="mailto:schique@gmail.com" className="hover:text-primary transition duration-300">
              <ContactItem IconComponent={FaEnvelope} label="Email">
                <p className="hover:text-primary transition duration-300">
                  schique@gmail.com
                </p>
              </ContactItem>
            </a>
          </motion.div>
          <motion.div
            className="flex flex-wrap gap-4 rounded-xl overflow-hidden order-1 lg:order-2 w-full"
            variants={containerVariants}
          >
            <div className="map-responsive w-full aspect-[16/9]">
              <motion.iframe
                width="100%"
                height="100%"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3113.4027350147776!2d-9.290218024062892!3d38.70856167176495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1eceae480e14b9%3A0x452b3883f5619a9b!2sSChique%20-%20Beauty%20Lounge%20-%20Cabeleireiro%20-%20Est%C3%A9tica!5e0!3m2!1spt-PT!2spt!4v1745244536473!5m2!1spt-PT!2spt"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                onLoad={() => setIsMapLoaded(true)}
                initial="hidden"
                animate={isMapLoaded ? "visible" : "hidden"}
                variants={mapVariants}
              ></motion.iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default ContactsPage; 